/* eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Headroom from 'react-headroom';
// import stores
import {
    getDetails,
    // login,
    useAuthState,
} from './stores/authStore';
import { useModuleDrawerState } from './hookState/ModuleDrawerState';
// import utility and constants
import Helper from './utility/helper';
import Header from './components/Header/Header';
import InnerRouter from './router/InnerRouter';
import NavBar from './components/Nav/NavBar/NavBar';
import ModuleDrawer from './modules/Module/moduleDrawer';
import UnauthorizedUI from './sharedcomponents/emptyStateContainer/unauthorizedUI';
import ApiHelper from './utility/ApiHelper';
import APIURLConstants from './config/config';
import CircularProgress from '@mui/material/CircularProgress';
import { setDrawerOpen } from './hookState/ModuleDrawerState';
import { isEmpty } from 'lodash-es';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const Main = ({ themeState }) => {
    const [isAgent, setIsAgent] = useState(false);
    const authState = useAuthState();

    const moduleDrawerState = useModuleDrawerState();

    useEffect(() => {
        setTimeout(async () => {
            // eslint-disable-next-line no-debugger
            // debugger
            if (Helper.getStorage('accessToken') != null) {
                // if (Helper.getStorage('chk') == 'aad') {
                //     await login();
                // }
                // else { 
                const userInfo = Helper.getStorage('userInfo');
                // debugger
                const eventInfo = Helper.getStorage('eventInfo');
                let eventRole = '';
                if (!isEmpty(eventInfo)) {
                    eventRole =
                        userInfo && userInfo.roles
                            ? userInfo.roles.find(
                                (item) => item.eventID === eventInfo.eventID
                            )?.eventRole
                            : '';
                }
                // console.log("eventRole",eventRole, !isEmpty(eventRole) ? "true" :"false");
                if ((userInfo != null && userInfo != undefined) && (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) || !isEmpty(eventRole)) {

                    let name = Helper.getURLSlug();
                    // console.log(name)
                    // console.log(typeof(name)==="string")
                    if (
                        name === 'transportation' ||
                        name === 'registrations' ||
                        name === 'draftregistration' ||
                        name === 'invitations' ||
                        name === 'hotel' ||
                        name === 'drafthotel' ||
                        name === 'outfit' ||
                        name === 'ticket' ||
                        name === 'allstarticket' ||
                        name === 'draftregister' ||
                        name === 'register' ||
                        name === 'allstarhotel' ||
                        name === 'draftTransportation' ||
                        name === 'drafttransportation' ||
                        name === 'combinetransportation' ||
                        name === 'combineTransportation' ||
                        name === 'combineregistration' ||
                        name === 'vip' ||
                        name === 'socialresponsibility' ||
                        name === 'socialResponsibility' ||
                        name === 'allStarEndUserTicket' ||
                        name === 'allstarregistration' ||
                        name === 'credential' ||
                        name === 'flightinfo' ||
                        name === 'lunchroom' ||
                        name === 'greenroom' ||
                        name === 'draftFlightInfo'
                    ) {
                        ApiHelper.get(
                            APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false)
                        ).then((res) => {
                            const newData = res.data;
                            setDrawerOpen(newData);
                        });
                        // setIsModule(true);
                    }
                }
                await getDetails();
                // await isArguments();
                // await GetEvents();
                // }
            }
        }, 1000);

    }, []);
    const GetEvents = async () => {
        const userInfo = Helper.getStorage('userInfo');
        ApiHelper.get(APIURLConstants.GET_EVENT_USERS(userInfo.userID, 0))
            .then((res) => {
                Helper.setStorage('UserEvents', res.data);
                if (res.data.length === 1) {
                    isAgents(res.data[0].eventID)
                }
            })
    }

    const isAgents = (eventID) => {
        const userInfo = Helper.getStorage('userInfo');
        ApiHelper.get(
            APIURLConstants.IS_AGENT(userInfo.userID, eventID)
        ).then((res) => {
            setIsAgent(res.data.agent);
        })
    }

    return (
        <>
            {authState.noAccess.get() != undefined &&
                authState.noAccess.value ? (
                <UnauthorizedUI showLogout={true} />
            ) : (
                <>
                    <Headroom>{authState && <Header />}</Headroom>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                // flexDirection: 'row',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row',
                                },
                                marginTop: '60px',
                            }}>
                            <Box
                                sx={{
                                    display: {
                                        xs: 'none',
                                        md: 'block',
                                    },
                                }}>
                                {authState && authState.isLoggedIn.value ? (
                                    <NavBar />
                                ) : null}
                            </Box>
                            <Box>
                                {moduleDrawerState.open.value ? (
                                    <ModuleDrawer
                                        modules={moduleDrawerState.modules.get()}
                                    />
                                ) : null}
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    width: '100%',
                                    backgroundColor:
                                        themeState.appbackground.value,
                                    // height: 'calc(100vh - 72px)',
                                    overflowY: 'auto',
                                    //p: 2,
                                    height: 'calc(100vh - 70px)',
                                    //minHeight: '500px',
                                    maxHeight: 'calc(100vh - 70px)',
                                    // zIndex: 0,
                                }}>
                                {authState && authState.isLoggedIn.value ? (
                                    <InnerRouter />
                                ) : (
                                    <Box
                                        sx={{ marginTop: '50px' }}
                                        style={loader}>
                                        <CircularProgress />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </>
            )}
        </>
    );
};
export default Main;
